// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"b48baf5d","466":"68200a74","496":"75f7a62d","738":"7f56f18f","856":"179027ff"}[chunkId] + ".chunk.js";
};